/**
 * cart-actions.js
 * Drop-in remove/quantity handling for a custom Shopify theme.
 * Works on the /cart page AND a cart drawer, using the same markup contract.
 *
 * HOW IT WORKS
 * - Listens for clicks on [data-cart-remove="{{ item.key }}"]
 * - Listens for change events on [data-cart-quantity="{{ item.key }}"] (a <input type="number">)
 * - Calls Shopify's native /cart/change.js endpoint (no app, no API keys needed)
 * - Re-renders any wrapper elements marked [data-section-id="..."] using Shopify's
 *   Section Rendering API, so the cart page AND drawer both update without a full reload
 * - Falls back to a full page reload on /cart if section rendering isn't wired up yet,
 *   so it's never silently broken even before you finish the markup side
 *
 * INSTALL
 * 1. Save this file as assets/cart-actions.js in your theme.
 * 2. Add near the closing </body> tag (theme.liquid):
 *      <script src="{{ 'cart-actions.js' | asset_url }}" defer></script>
 * 3. Add the markup below to your cart line-item snippet (both cart page + drawer partials).
 */
(function () {
  function getSectionIds() {
    return Array.from(document.querySelectorAll('[data-section-id]')).map(function (el) {
      return el.getAttribute('data-section-id');
    });
  }

  function replaceSections(sections) {
    var replacedAny = false;
    Object.keys(sections || {}).forEach(function (id) {
      var target = document.querySelector('[data-section-id="' + id + '"]');
      if (!target) return;
      var temp = document.createElement('div');
      temp.innerHTML = sections[id];
      var fresh = temp.querySelector('[data-section-id="' + id + '"]') || temp.firstElementChild;
      if (fresh) {
        target.replaceWith(fresh);
        replacedAny = true;
      }
    });
    return replacedAny;
  }

  function removeLineFallback(key) {
    // Minimal fallback if section rendering isn't wired up on this theme yet:
    // just remove the row from the DOM so the UI isn't stuck showing a deleted item.
    document.querySelectorAll('[data-cart-remove="' + key + '"]').forEach(function (btn) {
      var row = btn.closest('[data-cart-line]') || btn.closest('tr') || btn.closest('li');
      if (row) row.remove();
    });
  }

  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function changeLine(key, quantity) {
    var sectionIds = getSectionIds();

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var replaced = sectionIds.length ? replaceSections(cart.sections) : false;
        updateCartCount(cart);

        if (!replaced) {
          if (quantity === 0) removeLineFallback(key);
          if (window.location.pathname === '/cart') {
            window.location.reload();
          }
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      })
      .catch(function (err) {
        console.error('[cart-actions] failed to update cart', err);
      });
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    e.preventDefault();
    var key = removeBtn.getAttribute('data-cart-remove');
    removeBtn.setAttribute('disabled', 'disabled');
    changeLine(key, 0);
  });

  document.addEventListener('change', function (e) {
    var qtyInput = e.target.closest('[data-cart-quantity]');
    if (!qtyInput) return;
    var key = qtyInput.getAttribute('data-cart-quantity');
    var quantity = parseInt(qtyInput.value, 10);
    if (isNaN(quantity) || quantity < 0) quantity = 0;
    changeLine(key, quantity);
  });
})();
